<div class="transport-registration-masterdata">
    <app-centered-scrollable-content>

        <div *ngIf="requiresValueConfirmation">
            {{'Please confirm the accuracy of the provided information using the mandatory checkboxes below.' |
            translate:
            ['tmc-yard.widgets.registration-terminal.transport-registration-masterdata.confirmation.description',
            translationService.language]}}
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </div>

        <div class="details-mask">
            {{'Fields marked with * are mandatory and must be filled in.' |
            translate:
            ['tmc-yard.widgets.registration-terminal.transport-registration-masterdata.mandatoryfields.hint',
            translationService.language]}}
            <app-transport-details [mode]="TransportDetailMode.EDITING" [layout]="layoutDefinition"
                [transport]="transportDetails" (valueChange)="onTransportDetailsChanged()"
                (validState)="validStateChanged($event)" [disableAutoComplete]="true">
            </app-transport-details>
            <!-- features nachziehen -->
            <!--app-transport-details [mode]="TransportDetailMode.EDITING" [layout]="layoutDefinition"
            [requiresValueConfirmation]="requiresValueConfirmation" [showHints]="showHints" [transport]="transportDetails"
            [autocompletionEnabled]="false" (transportDetailsChanged)="onTransportDetailsChanged()" (validState)="validStateChanged($event)">
        </app-transport-details-->
        </div>
    </app-centered-scrollable-content>
</div>
